// LLM generated - Model Claude 4 Sonnet
import useTranslation from 'next-translate/useTranslation';

import Image from '~/domains/common/components/Image/Image';
import ImagePlaceholder from '~/domains/common/components/Image/ImagePlaceholder';
import { Text } from '~/domains/design-system/Text';
import dt from '~/domains/contest/domains/gamecenter/testing.const';

import type { Pick } from './TeamSurvivorEntryDisplay';
import { useTeamPickIconDisplayStyles } from './TeamSurvivorEntryDisplay.styles';

export type TeamPickIconDisplayProps = {
  picks: (Pick | null)[];
  isSlateMissingPicks: boolean;
  isMakePicks?: boolean;
  requiredPicksCount: number;
  canMakePicks?: boolean;
  hasHiddenPicks?: boolean;
};

export function TeamPickIconDisplay({
  picks,
  isSlateMissingPicks,
  isMakePicks,
  requiredPicksCount,
  canMakePicks = true,
  hasHiddenPicks = false,
}: TeamPickIconDisplayProps) {
  const { classes } = useTeamPickIconDisplayStyles();
  const { t } = useTranslation('contest');

  if (isSlateMissingPicks) {
    if (!isMakePicks) {
      return null;
    }

    return (
      <Text variant="subhead-small" className={classes.makePick}>
        {canMakePicks
          ? t('gamecenter.common.makePicks__hasPlural', {
              count: requiredPicksCount,
            })
          : t('gamecenter.common.noPicks__hasPlural', {
              count: requiredPicksCount,
            })}
      </Text>
    );
  }

  if (hasHiddenPicks) {
    return (
      <Text variant="subhead-small" className={classes.makePick}>
        {t('gamecenter.common.pickSelected__hasPlural', {
          count: requiredPicksCount,
        })}
      </Text>
    );
  }

  if (!picks.length) return null;

  return (
    <>
      {picks.map((pick) => (
        <div
          className={classes.slatePick}
          key={pick.id}
          data-test-id={dt.team.entriesScheduled.entry.team}
        >
          <div className={classes.pickImage}>
            <Image
              src={pick.image}
              alt={pick.name}
              fill
              fallbackComponent={<ImagePlaceholder width={48} height={48} />}
            />
          </div>
          <Text
            variant="headline-small"
            className={classes.pickName}
            data-test-id={dt.team.entriesScheduled.entry.teamAbbr}
          >
            {pick.name}
          </Text>
          {typeof pick.spread === 'string' && (
            <Text variant="subhead-xx-small" className={classes.pickSpread}>
              {pick.spread}
            </Text>
          )}
        </div>
      ))}
    </>
  );
}
